<template>
  <SideBlock
    class="ProfessionPriceRangesBox"
    :title="
      $t('profPriceRangesBox.title', {
        professionName: $helpers.capitalize(profession.name),
      })
    "
  >
    <div class="grid gap-1">
      <!-- JSZK2-2466 Show all profession tasks, not only the ones with minimum price-->
      <div
        v-for="(task, index) in professionTasks"
        :key="index"
        class="flex justify-between"
      >
        <NuxtLink
          :to="
            localePath({
              name: 'prices',
              params: { professionTask: task.seoName },
            })
          "
          class="capitalize"
        >
          {{ task.name }}
        </NuxtLink>
        <div v-if="task.minimumPrice" class="font-bold text-blog-primary">
          {{ $n(task.minimumPrice, "currency") }} / {{ task.unit }}
        </div>
      </div>
    </div>
    <p class="my-2">
      {{ $t("profPriceRangesBox.sideBlock") }}
    </p>
  </SideBlock>
</template>

<script>
import SideBlock from "~/components/_refactored/mainpage/SideBlock.vue";

export default {
  components: { SideBlock },
  props: {
    professionTasks: {
      type: Array,
      required: true,
    },
    profession: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // Includes only profession tasks with minimum price
    professionTasksWithPrice() {
      return this.professionTasks.filter((task) => task.minimumPrice);
    },
  },
};
</script>
